import React from 'react'
import { makeStyles, useTheme } from '@mui/styles'

import config from 'config'
import lang from '@/lang'
import ThemeInterface from '@/theme-interface'
import WisoIconLight from '@assets/images/logo/svg/wiso_logo-light.svg'
import BuhlLogoLight from '@assets/images/logo/svg/buhl_logo-light.svg'
import WisoIconDark from '@assets/images/logo/svg/wiso_logo-dark.svg'
import BuhlLogoDark from '@assets/images/logo/svg/buhl_logo-dark.svg'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import { ColorModes } from '@/modules/layout/constants'

const { agbUrl, imprintUrl, privacyUrl } = config

const useStyles = makeStyles((theme: ThemeInterface) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    background: theme.mode.backgroundColor.medium,
    color: theme.mode.color.medium,
    fontSize: theme.fontSizes.smaller,
    padding: '18px 32px',
    '& a': {
      color: theme.mode.color.medium,
      '&:hover': {
        color: theme.primaryBright,
      },
    },
  },
  links: {
    display: 'flex',
    flexDirection: 'column',
  },
  logos: {
    alignSelf: 'flex-end',
    '& span:first-child': {
      marginRight: 10,
    },
  },
}), { name: 'AccountPopoverFooter' })

const AccountPopoverFooter = () => {
  const classes = useStyles()
  const theme: ThemeInterface = useTheme()

  return (
    <div className={classes.root}>
      <div className={classes.links}>
        <div>
          <a href={agbUrl} rel="noopener noreferrer" target="_blank">{lang.footer.agb}</a>{' '}&{' '}
          <a href={privacyUrl} rel="noopener noreferrer" target="_blank">{lang.footer.legal}</a>
        </div>
        <a href={imprintUrl} rel="noopener noreferrer" target="_blank">{lang.footer.impressum}</a>
        <a onClick={() => UC_UI?.showSecondLayer()}>{lang.footer.cookies}</a>
      </div>
      <div className={classes.logos}>
        <SVGIcon svg={theme.mode.type === ColorModes.dark ? WisoIconDark : WisoIconLight} height="24px" width="70px" />
        <SVGIcon svg={theme.mode.type === ColorModes.dark ? BuhlLogoDark : BuhlLogoLight} height="24px" width="70px" />
      </div>
    </div>
  )
}

export default AccountPopoverFooter
